import type { CSSObject } from "type/tss";
import { Theme } from "@mui/material/styles";
import * as env from "shared/env";

export const styles = (theme: Theme) => {
	return {
		centeredCell: {
			display: "flex",
			width: "100%",
			alignItems: "center",
			justifyContent: "center",
		},
		reactTable: {
			"& .rt-tr-group .delete": {
				visibility: "hidden",
			},
			"& .rt-tr-group:hover .delete": {
				visibility: "visible",
			},
			"& .-pagination": {
				"& .-pageJump": {
					display: "none",
				},
				"& .-totalPages": {
					display: "none",
				}
			},
			
		},
		dialogText: {
			paddingTop: 5, 
		},
		dialogContent: {
			[theme.breakpoints.down("xs")]: {
				display: "flex",
				alignItems: "flex-end",
				textAlign: "center",
			},
		},
		dialogActions: {
			[theme.breakpoints.down("xs")]: {
				height: "50%",
				justifyContent: "center",
				alignItems: "flex-start",
				paddingLeft: 30,
				paddingRight: 30,
				"& button": {
					flex: 1,
				},
			},
		},
		formControl: {
			minWidth: 200,

		},
		headerRow: {
			width: "100%",
		},
		searchItem: {
			flexGrow: 0,
			minWidth: "15rem",
		},
		searchInput: {
			width: "29rem",
			maxWidth: "29rem",
			height: "2.5rem",
			backgroundColor: "white",
			border: "1px solid #ebebeb",
			borderRadius: 4,
			padding: "0.5rem 1rem",
			fontSize: "1rem",
			fontFamily: theme.typography.fontFamily,
		},
		searchInputMobile: {
			width: "100%",
			maxWidth: "100%",
		},
		searchIcon: {
			color: theme.palette.primary.main,
		},
		headerButton: {
			height: "2.5rem",
			minHeight: "2.5rem",
			whiteSpace: "nowrap",
			fontSize: "1rem",
			fontWeight: 500,
			borderRadius: 4,
			fontFamily: theme.typography.fontFamily,
			padding: "0 1rem",
		},
		iconOnlyButton: {
			minWidth: "2.5rem",
			padding: 0,
		},
		outlinedButton: {
			backgroundColor: "white",
			borderColor: theme.palette.primary.main,
			color: theme.palette.primary.main,
		},
		outlinedButtonDisabled: {
			backgroundColor: "#f3f4f6",
			borderColor: "#c9c9c9",
			color: "#9b9b9b",
		},
		containedPrimaryButton: {
			backgroundColor: theme.palette.primary.main,
			color: "white",
		},
		textButton: {
			height: "2.5rem",
			minHeight: "2.5rem",
			fontSize: "1rem",
			fontWeight: 500,
			padding: "0 1rem",
			borderRadius: 4,
			fontFamily: theme.typography.fontFamily,
		},
		textButtonEnabled: {
			color: theme.palette.primary.main,
		},
		textButtonDisabled: {
			color: "#939393",
		},
		buttonIcon: {
			color: theme.palette.primary.main,
			width: 16,
			height: 16,
		},
		buttonIconDisabled: {
			color: "#939393",
			width: 16,
			height: 16,
		},
		buttonIconMuted: {
			color: "#9b9b9b",
		},
		buttonIconOnPrimary: {
			color: "white",
		},
		headerSpacer: {
			flexGrow: 1,
		},
		leadStatusSelect: {
			"& .MuiInputBase-root": {
				height: "2.5rem",
				minHeight: "2.5rem",
				borderRadius: 4,
				fontSize: "1rem",
				fontWeight: 500,
				fontFamily: theme.typography.fontFamily,
			},
			"& .MuiSelect-select": {
				display: "flex",
				alignItems: "center",
				padding: "0 2.25rem 0 0.75rem",
			},
			"& .MuiOutlinedInput-notchedOutline": {
				borderColor: "#ebebeb",
			},
			"& .MuiSelect-icon": {
				color: "#6b7280",
			},
		},
		menuPaper: {
			maxHeight: 400,
		},
		bannerWrapper: {
			padding: "0 0 0.75rem",
		},
		infoAlert: {
			backgroundColor: "rgba(201, 244, 249, 0.5)",
		},
		successAlert: {
			backgroundColor: "#C6F5D7",
		},
		progressAlertContent: {
			alignItems: "flex-start",
		},
		progressBarContainer: {
			width: "100%",
		},
		progressBar: {
			marginTop: "0.5rem",
		},
		tableLoading: {
			padding: "1rem",
			textAlign: "center",
		},
		phoneText: {
			color: "#555",
			fontSize: "0.875rem",
		},
		leadImportDialogPaper: {
			maxWidth: "60rem",
		},
		leadImportDialogActions: {
			padding: "1rem",
		},
		tagChip: {
			margin: 2,
		},
		recentlyImportedRow: {
			backgroundColor: "rgba(255, 239, 214, 0.5)",
			"&:hover": {
				backgroundColor: "rgba(255, 239, 214, 0.5)",
			},
		},
		focusedLeadRow: {
			backgroundColor: theme.palette.action.selected,
			"&:hover": {
				backgroundColor: theme.palette.action.selected,
			},
		},
		tableContainer: {
			width: "100%",
		},
		deleteIconButton: {
			color: theme.palette.error.main,
		}
	} satisfies Record<string, CSSObject>;
};
